import React, {useContext, useEffect, useRef, useState} from 'react';
import {Card, Col, Row, Image, CardBody, Spinner} from "react-bootstrap";
import { observer } from "mobx-react-lite";
import {FaArrowRightFromBracket} from "react-icons/fa6";
import {FaBook, FaCoins, FaDollarSign, FaShoePrints, FaSortAmountDownAlt, FaSortAmountUpAlt} from "react-icons/fa";
import {Context} from "../../index";
import {editAssignment} from "../../http/bookAPI";
import Loader from "../Loader";
import {toast} from "react-toastify";
import TripleSpinner from "../../helpers/TripleSpinner";

const CoverWithSpinner = ({
                              src,
                              fallbackSrc,
                              alt = "",
                              width = "auto",
                              height = 148,
                              fetchPriority = "auto",
                              style = {},
                          }) => {
    const [loaded, setLoaded] = useState(false);
    const [err, setErr] = useState(false);

    const finalSrc = err ? fallbackSrc : src;

    return (
        <div
            style={{
                position: "relative",
                width,
                height,
                borderRadius: 8,
                overflow: "hidden",
                background: "#fff",
                ...style,
            }}
        >
            {!loaded && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    aria-hidden="true"
                >
                    <TripleSpinner size={24} gapRatio={0.8} />
                </div>
            )}

            <img
                src={finalSrc}
                alt={alt}
                loading="lazy"
                decoding="async"
                fetchpriority={fetchPriority}
                onLoad={() => setLoaded(true)}
                onError={() => {
                    setErr(true);
                    setLoaded(true);
                }}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                    opacity: loaded ? 1 : 0,
                    transition: "opacity 500ms ease-in",
                    backgroundColor: "white",
                    paddingTop: 3,
                    paddingBottom: 3,
                    borderRadius: 6,
                }}
            />
        </div>
    );
};

const AssignLibraryItem3x = observer(({ bookitem, onOpen, alwaysOnTopBadge = null }) => {
     const { book } = useContext(Context);
    const currentTimeInMinutes = Math.floor(Date.now() / 60000);
    const date = new Date((currentTimeInMinutes + bookitem.turnaround_time) * 60 * 1000);
// Массив с сокращениями месяцев
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();
    const [loading, setLoading] = useState(true); // Состояние загрузки

    const isMobile = window.innerWidth < 480; // или useMediaQuery
    const speedUpLevel = bookitem?.speed_up_level || 0;

const daysToRead = Math.ceil(bookitem.turnaround_time / 60 / 24 );

    const [bonus, setBonus] = useState(null);
    const [columns, setColumns] = useState(6);

    const coverSrc = bookitem.book.cover_file
        ? `${process.env.REACT_APP_API_URL}covers/${bookitem.book.cover_file}`
        : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;

    const fallbackCoverSrc = `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;


    const ModalOpen = async () => {

        await editAssignmentWhenOpenModal();
        onOpen(bookitem, bonus)
    };

    const editAssignmentWhenOpenModal = async () => {
        try {
            await editAssignment({
                id: bookitem?.id,
                clicks: bookitem?.clicks + 1,
            });
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred while calculating user assignments.";
            toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return null;
        }
    };

    useEffect(() => {
        setLoading(true); // Перед загрузкой данных включаем лоадер
        const handleResize = () => {
            const width = window.innerWidth;

            if (width >= 3300) setColumns(2);
            else if (width >= 2200) setColumns(3);
            else if (width >= 1680) setColumns(4);
            else if (width >= 1200) setColumns(6);
            else setColumns(12);
        };

        handleResize(); // Установить при первом рендере
        window.addEventListener('resize', handleResize);
        setLoading (false);
        return () => window.removeEventListener('resize', handleResize);

    }, []);

    useEffect(() => {
        let totalBonus = 0;
        const now = Date.now() / 60000; // Преобразуем текущую дату в минуты

        // Бонус по типу ассигмента
        if (book?.asstypes) {
            const assignmentType = book.asstypes.find(type => type.id === bookitem.assTypeId);
            if (assignmentType &&
                assignmentType.promotion_ass_price_bonus &&
                assignmentType.promotion_ass_price_bonus_start_date <= now &&
                assignmentType.promotion_ass_price_bonus_end_date >= now
            ) {
                totalBonus += assignmentType.promotion_ass_price_bonus;
            }
        }

        // Бонус по типу книги
        if (book?.types) {
            const bookType = book.types.find(type => type.id === bookitem.booksTypeId);
            if (bookType &&
                bookType.book_type_promotion_price_bonus &&
                bookType.book_type_promotion_price_bonus_start_date <= now &&
                bookType.book_type_promotion_price_bonus_end_date >= now
            ) {
                totalBonus += bookType.book_type_promotion_price_bonus;
            }
        }

        // Бонус по типу цены
        if (book?.prices) {
            const priceType = book.prices.find(price => price.id === bookitem.booksPriceId);
            if (priceType &&
                priceType.promotion_price_bonus &&
                priceType.promotion_price_bonus_start_date <= now &&
                priceType.promotion_price_bonus_end_date >= now
            ) {
                totalBonus += priceType.promotion_price_bonus;
            }
        }

        setBonus(totalBonus);
    }, [book]);

    const isFreePromo = [3, 32].includes(Number(bookitem?.assTypeId)) && Number(bookitem?.booksPriceId) === 1;

    return (
        <>
            {loading ? ( <> <Loader /> </> ) : (
                <>
                    {!isMobile && (
                        <Col md={12} className="mt-0 d-flex justify-content-center align-items-center p-0">
                            <div className="assignment-card" data-assignment-id={bookitem.id}></div>
                            {/* === Десктопная карточка (оставлена без изменений) === */}
                            <Card
                                className="mt-0 mb-3 mx-2 "
                                style={{
                                    borderRadius: '6px',
                                    boxShadow: isFreePromo
                                        ? '0px 0px 12px 4px rgba(255, 215, 0, 0.5)'
                                        : '0px 4px 12px rgba(0, 0, 0, 0.1)',
                                    border: (() => {
                                        if (isFreePromo && speedUpLevel === 0) return '1px solid gold';
                                        switch (speedUpLevel) {
                                            case 1:
                                                return '2px solid gray';
                                            case 2:
                                                return '2px solid green';
                                            case 3:
                                                return '2px solid gold';
                                            case 5:
                                                return '2px solid gray';
                                            case 6:
                                                return '2px solid green';
                                            case 7:
                                                return '2px solid gold';
                                            default:
                                                return '1px solid gray';
                                        }
                                    })(),
                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                    cursor: 'pointer',
                                    height: '174px',
                                    position: 'relative',
                                    animation: (() => {
                                        if (isFreePromo || [4, 5, 6, 7].includes(speedUpLevel)) {
                                            return 'promoPulse 1.5s ease-in-out infinite';
                                        }
                                        return 'none';
                                    })(),
                                }}

                                onClick={ModalOpen}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = '0px 2px 4px rgba(0, 0, 0, 0.1)';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                {alwaysOnTopBadge && (
                                    <span
                                        className={`badge ${alwaysOnTopBadge.className} text-uppercase position-absolute`}
                                        style={{
                                            top: '6px',
                                            left: '8px',
                                            borderRadius: '4px',
                                            padding: '3px 6px',
                                            fontSize: '0.62rem',
                                            fontWeight: 'bold',
                                            lineHeight: '1',
                                            whiteSpace: 'nowrap',
                                            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.12)',
                                            zIndex: 2,
                                        }}
                                    >
                                        {alwaysOnTopBadge.label}
                                    </span>
                                )}
                                <Card.Body style={{ paddingTop: '12px' }}>
                                    <Row className="p-0">
                                            <Col md={4} className="d-flex justify-content-center align-items-center position-relative"
                                                 style={{
                                                     borderRadius: "6px",
                                                     overflow: "hidden",
                                                     backgroundColor: "white",

                                                 }}
                                            >
                                                <CoverWithSpinner
                                                  src={coverSrc}
                                                  fallbackSrc={fallbackCoverSrc}
                                                  alt={bookitem.book.title}

                                                  height={148}
                                                />
                                            </Col>


                                        <Col md={8} className="flex-column justify-content-lg-start px-1 align-text-top p-0">
                                            <p
                                                className="fw-bold mb-0 text-muted"
                                                style={{
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    WebkitLineClamp: 1, // Ограничение до 1 строки
                                                }}
                                            >
                                                {bookitem.book.title}
                                            </p>

                                            <p
                                                className="fst-italic mb-2 text-muted small"
                                                style={{
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    WebkitLineClamp: 1,
                                                    fontSize: '0.80rem',
                                                    lineHeight: '1.0rem',
                                                }}
                                            >
                                                {bookitem.book.subtitle}
                                            </p>

                                            <Row className="text-muted" style={{ fontSize: '0.9rem', lineHeight: '1.1rem'}}>
                                                <p className="me-2 mb-0 mt-0 small text-muted">
                                                    <FaSortAmountUpAlt className="me-2"/>
                                                    <span>Due: {`${month}-${day}`}; Finish in {daysToRead} Day{daysToRead > 1 && 's'}</span>
                                                </p>

                                                <p className=" mb-0 mt-0 small text-muted">
                                                    <FaArrowRightFromBracket className="me-1 mb-0 mt-0 small text-muted"/>
                                                    <span className="text-muted small fst-italic"> {bookitem.book.total_words} Words, </span>
                                                    <strong>Earnings: <span className="text-success">{bookitem.assignment_price_reader} Virt</span> </strong>
                                                </p>
                                                <p className=" mb-0 mt-0 small text-muted">
                                                    <FaBook className="me-2 mb-0 mt-0 small text-muted"/>
                                                    Type: <strong>
                                                        {bookitem?.assTypeId === 1 && "Universal Assignment"}
                                                        {bookitem.assTypeId === 2 && "Kindle Unlimited"}
                                                        {bookitem.assTypeId === 3 && "Verified Purchase"}
                                                        {bookitem.assTypeId === 4 && "Verified Purchase Img"}
                                                        {bookitem.assTypeId === 5 && "Ver/Pur Search&Buy"}
                                                        {bookitem.assTypeId === 6 && "Ver/Pur Search&Buy Img"}
                                                        {bookitem.assTypeId === 7 && "Universal Audio"}
                                                        {bookitem.assTypeId === 8 && "Audible Promo Code"}
                                                        {bookitem.assTypeId === 9 && "Verified Kindle Unlimited"}
                                                    {bookitem.assTypeId === 10 && "Paperback Buyout"}
                                                    {bookitem.assTypeId === 11 && "PB Search&BuyOut"}
                                                    {bookitem.assTypeId === 12 && "PB Verified + Img"}
                                                    {bookitem.assTypeId === 13 && "PB Verified + Video"}
                                                    {bookitem.assTypeId === 14 && "Hardcover BuyOut"}
                                                    {bookitem.assTypeId === 15 && "HC Search&BuyOut"}
                                                    {bookitem.assTypeId === 16 && "HC Verified + Img"}
                                                    {bookitem.assTypeId === 17 && "HC Verified + Video"}
                                                    {bookitem.assTypeId === 18 && "PB Verified Purchase"}
                                                    {bookitem.assTypeId === 19 && "PB Verified Search&Buy"}
                                                    {bookitem.assTypeId === 20 && "HC Verified Purchase"}
                                                    {bookitem.assTypeId === 21 && "HC Verified Search&Buy"}
                                                    {bookitem.assTypeId === 22 && "Product BuyOut"}
                                                    {bookitem.assTypeId === 23 && "Product Search&BuyOut"}
                                                    {bookitem.assTypeId === 24 && "Product Verified Purchase"}
                                                    {bookitem.assTypeId === 25 && "Product Verified + Img"}
                                                    {bookitem.assTypeId === 26 && "Product Verified + Video"}
                                                    {bookitem.assTypeId === 27 && "Product Verified Search&Buy"}
                                                    {bookitem.assTypeId === 28 && "Make Helpful Internal"}
                                                    {bookitem.assTypeId === 29 && "Write Report Internal"}
                                                    {bookitem.assTypeId === 30 && "Make Helpful External"}
                                                    {bookitem.assTypeId === 31 && "Write Report External"}
                                                    {bookitem.assTypeId === 32 && "Set Stars Rating"}

                                                    </strong> (<span className="text-success">
                                                        {bookitem.booksTypeId === 1 && "Kindle"}
                                                    {bookitem.booksTypeId === 2 && "Paperback"}
                                                    {bookitem.booksTypeId === 3 && "Hardcover"}
                                                    {bookitem.booksTypeId === 4 && "Audio"}
                                                    {bookitem.booksTypeId === 5 && "Helpful"}
                                                    {bookitem.booksTypeId === 6 && "Report"}
                                                    {bookitem.booksTypeId === 7 && "Product"}
                                                    {bookitem.booksTypeId === 8 && "Product"}
                                                    {bookitem.booksTypeId === 9 && "Product"}
                                                    {bookitem.booksTypeId === 10 && "Product"}

                                                    </span>)
                                                </p>


                                                <p className=" mb-0 mt-0 small text-muted">
                                                    <FaShoePrints className="me-2 mb-0 mt-0 small text-muted"/>
                                                    To Do: <span className="text-success">
                                                        {Number(bookitem?.assTypeId) === 32 ? "Leave star rating" : bookitem.assignment_type}
                                                    </span>
                                                </p>
                                                <p className="mb-0 mt-0 small text-muted">
                                                    <FaDollarSign className="me-2 mb-1 mt-0 small text-muted" />
                                                    {bookitem?.assTypeId === 1 && (
                                                        <strong className="text-danger">Free File Download</strong>
                                                    )}
                                                    {bookitem?.assTypeId === 2 && (
                                                        <strong className="text-danger">Requires Kindle Unlimited</strong>
                                                    )}
                                                    {bookitem?.assTypeId === 8 && (
                                                        <strong className="text-danger">Free Audible Promo Code</strong>
                                                    )}
                                                    {bookitem?.assTypeId === 9 && (
                                                        <strong className="text-danger">Requires Paid KU Subscription</strong>
                                                    )}
                                                    {[10,11,12,13,14,15,16,17,18,19,20,21].includes(bookitem?.assTypeId) && (
                                                        <strong className="text-danger">Buy Book & Get Full Refund: ${bookitem?.book_cost_compensation}</strong>
                                                    )}
                                                    {[22,23,24,25,26,27].includes(bookitem?.assTypeId) && (
                                                        <strong className="text-danger">Buy Product & Get Refund: ${bookitem?.book_cost_compensation}</strong>
                                                    )}
                                                    {[3, 4, 5, 6, 32].includes(bookitem?.assTypeId) && (
                                                        bookitem?.assignment_price_amz === "Free Promotion" ? (
                                                            <strong className="text-danger">HOT!!! $0.00 Free Promo</strong>
                                                        ) : (
                                                            <strong className="text-danger">
                                                                Requires Book Purchase: {bookitem.assignment_price_amz}
                                                            </strong>
                                                        )
                                                    )}
                                                    {[28,29,30,31].includes(bookitem?.assTypeId) && (
                                                        <strong className="text-danger">Free Tap (Existing Review)</strong>
                                                    )}
                                                </p>

                                            </Row>

                                            {isFreePromo && (
                                                <span
                                                      style={{
                                                          position: 'absolute',
                                                          top: '148px',
                                                          right: '150px',
                                                          backgroundColor: 'yellowgreen',
                                                          borderRadius: '4px', // Делаем скругленные углы
                                                          padding: '1px 6px', // Отступы по бокам для адаптации ширины
                                                          height: 'auto', // Автоматическая высота
                                                          display: 'inline-flex', // Гибкий контейнер, но не растягивается
                                                          justifyContent: 'center',
                                                          alignItems: 'center',
                                                          fontSize: '0.7rem',
                                                          fontWeight: 'bold',
                                                          color: 'black',
                                                          whiteSpace: 'nowrap', // Не дает тексту переноситься
                                                          boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                                                      }}>
                                                Free Promotion
                                               </span>
                                            )}

                               {bonus > 0 && (
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        top: '148px',
                                                        right: '7px',
                                                        backgroundColor: 'yellowgreen',
                                                        borderRadius: '4px', // Делаем скругленные углы
                                                        padding: '1px 6px', // Отступы по бокам для адаптации ширины
                                                        height: 'auto', // Автоматическая высота
                                                        display: 'inline-flex', // Гибкий контейнер, но не растягивается
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        fontSize: '0.7rem',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        whiteSpace: 'nowrap', // Не дает тексту переноситься
                                                        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                                                    }}
                                                >
                                             +{bonus} Virt
                                                 </span>
                                            )}

                                        </Col>

                                    </Row>
                                </Card.Body>
                            </Card>



                        </Col>
                    )}

                    {isMobile && (
                        <Col xs={12} className="d-flex justify-content-center">
                            <div className="assignment-card" data-assignment-id={bookitem.id}></div>
                            {/* === Мобильная карточка: фото слева, текст справа === */}
                            <Card
                                className="mt-2 mb-2 p-2 mx-auto"
                                style={{
                                    borderRadius: '6px',
                                    boxShadow: isFreePromo
                                        ? '0 0 12px 4px rgba(255, 215, 0, 0.5)'
                                        : '0 2px 6px rgba(0,0,0,0.1)',
                                    width: '100%',
                                    cursor: 'pointer',
                                    maxWidth: '380px',
                                    position: 'relative',
                                    animation: (() => {
                                        if (isFreePromo || [4, 5, 6, 7].includes(speedUpLevel)) {
                                            return 'promoPulse 1.5s ease-in-out infinite';
                                        }
                                        return 'none';
                                    })(),
                                    border: (() => {
                                        if (isFreePromo) return '1px solid gold';
                                        switch (speedUpLevel) {
                                            case 1:
                                                return '2px solid gray';
                                            case 2:
                                                return '2px solid green';
                                            case 3:
                                                return '2px solid gold';
                                            case 5:
                                                return '2px solid gray';
                                            case 6:
                                                return '2px solid green';
                                            case 7:
                                                return '2px solid gold';
                                            default:
                                                return '1px solid gray';
                                        }
                                    })(),
                                }}
                                onClick={ModalOpen}
                            >
                                {alwaysOnTopBadge && (
                                    <span
                                        className={`badge ${alwaysOnTopBadge.className} text-uppercase position-absolute`}
                                        style={{
                                            top: '6px',
                                            left: '8px',
                                            borderRadius: '4px',
                                            padding: '3px 6px',
                                            fontSize: '0.62rem',
                                            fontWeight: 'bold',
                                            lineHeight: '1',
                                            whiteSpace: 'nowrap',
                                            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.12)',
                                            zIndex: 2,
                                        }}
                                    >
                                        {alwaysOnTopBadge.label}
                                    </span>
                                )}

                            <Row className="g-2 align-items-center">
                                    {/* Обложка */}
                                    <Col xs={4} className="d-flex justify-content-center">

                                        <CoverWithSpinner
                                            src={coverSrc}
                                            fallbackSrc={fallbackCoverSrc}
                                            alt={bookitem.book.title}

                                            height={104}
                                        />

                                    </Col>

                                    {/* Текстовая часть */}
                                    <Col xs={8}   style={{
                                        fontSize: '0.9em',
                                    }}>
                                        <p className="fw-bold mb-1 text-muted small"
                                           style={{
                                               lineHeight: '1.1em',
                                               display: '-webkit-box',
                                               WebkitBoxOrient: 'vertical',
                                               overflow: 'hidden',
                                               WebkitLineClamp: 1, // Ограничение до 2 строк
                                           }}
                                        >
                                            {bookitem.book.title}
                                        </p>
                                        <p className="fst-italic mb-2 text-muted small"
                                           style={{
                                               lineHeight: '1.1em',
                                               display: '-webkit-box',
                                               WebkitBoxOrient: 'vertical',
                                               overflow: 'hidden',
                                               WebkitLineClamp: 2, // Ограничение до 2 строк
                                           }}
                                           >
                                            {bookitem.book.subtitle}
                                        </p>

                                        <p className="mb-1 small text-muted"
                                           style={{
                                               lineHeight: '0.9em',
                                               display: '-webkit-box',
                                               WebkitBoxOrient: 'vertical',
                                               overflow: 'hidden',
                                               WebkitLineClamp: 1, // Ограничение до 2 строк
                                           }}
                                        >
                                            <FaSortAmountDownAlt className="me-1" />
                                            Due: <b>{`${month}-${day}`}</b>, {daysToRead} Day
                                        </p>

                                        <p
                                            className="mb-1 small text-muted"
                                            style={{
                                                lineHeight: '1em',
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                WebkitLineClamp: 1,
                                            }}
                                        >
                                            <FaArrowRightFromBracket className="me-1" />
                                            Earn: <b>{bookitem.assignment_price_reader} Virt</b>
                                            {bonus > 0 && (
                                                <>
                                                    {' '}
                                                    +<b>{bonus}</b> Bonus
                                                </>
                                            )}{<>
                                            <span className="text-success">
                                                        {bookitem.booksTypeId === 1 && " (Kindle)"}
                                            {bookitem.booksTypeId === 2 && " (Paperback)"}
                                            {bookitem.booksTypeId === 3 && " (Hardcover)"}
                                            {bookitem.booksTypeId === 4 && " (Audio)"}
                                                {bookitem.booksTypeId === 5 && " (Helpful)"}
                                                {bookitem.booksTypeId === 6 && " (Report)"}
                                                {bookitem.booksTypeId === 7 && "Product"}
                                                {bookitem.booksTypeId === 8 && "Product"}
                                                {bookitem.booksTypeId === 9 && "Product"}
                                                {bookitem.booksTypeId === 10 && "Product"}

                                                    </span>
                                        </>}
                                        </p>

                                        <p
                                            className="mb-1 small text-danger d-flex align-items-center"
                                            style={{
                                                lineHeight: "0.9em",
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                WebkitLineClamp: 1, // ограничение до одной строки
                                            }}
                                        >
                                            <FaCoins className="me-1 flex-shrink-0" />
                                            <span>
    {(() => {
        switch (bookitem?.assTypeId) {
            case 1:
                return <strong>Free File Download</strong>;
            case 2:
                return <strong>Requires Kindle Unlimited</strong>;
            case 8:
                return <strong>Free Audible Promo Code</strong>;
            case 9:
                return <strong>Requires Paid KU Subscrip..</strong>;
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
                return (
                    <strong className="text-danger">
                        Buy &amp; Get Refund: ${bookitem?.book_cost_compensation}
                    </strong>
                );
            case 28:
            case 29:
            case 30:
            case 31:
                return (
                    <strong className="text-danger">
                        Free Tap (Existing Review)
                    </strong>
                );
            default:
                if (bookitem?.assignment_price_amz === "Free Promotion") {
                    return (
                        <strong className="text-danger">
                            HOT!!! Buy For $0.00 Free Promo
                        </strong>
                    );
                }
                return (
                    <strong className="text-danger">
                        Requires Purchase: {bookitem.assignment_price_amz}
                    </strong>
                );
        }
    })()}
  </span>
                                        </p>



                                    </Col>
                                </Row>


                            </Card>

                        </Col>
                    )}
                </>
            )}
        </>
    );


});

export default AssignLibraryItem3x;
